import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationAdminUserRoutesModule } from './registration-admin-user-routes.module';
import { RegistrationAdminUserComponent } from './registration-admin-user.component';
import {
  DxFormModule,
  DxFileUploaderModule,
  DxLoadPanelModule,
  DxPopupModule,
  DxScrollViewModule,
  DxButtonModule,
} from 'devextreme-angular';
import { MedprodidModule } from 'src/app/shared/components/medprodid/medprodid.module';
import { DeaDataViewModule } from 'src/app/shared/components/dea-data-view/dea-data-view.module';
import { DefaultTermsComponent } from './terms/default-terms/default-terms.component';
import { DirectModule } from 'src/app/shared/components/direct/direct.module';
import { PipeModule } from 'src/app/pipe.module';

@NgModule({
  imports: [
    CommonModule,
    RegistrationAdminUserRoutesModule,
    DxFormModule,
    DxFileUploaderModule,
    DxLoadPanelModule,
    DxPopupModule,
    DxScrollViewModule,
    DxButtonModule,
    MedprodidModule,
    DeaDataViewModule,
    DirectModule,
    PipeModule,
  ],
  declarations: [RegistrationAdminUserComponent, DefaultTermsComponent],
  exports: [RegistrationAdminUserComponent],
})
export class RegistrationAdminUserModule {}
